// Example class
let _this = (module.exports = {

    // Set the dom elements
    dom: {
        body: document.querySelector('body')
    },

    // Set variables
    vars: {
        flag: false,
	},

    /**
     * Init functions
     */
    init: function() {
    
    }
});